<ng-container *ngIf="!viewTemplate; else viewVerification">
  <div class="content-loading">
    <div class="loader" id="loader">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    <br />
    <br />
    <h2 class="loading">Espere porfavor...</h2>
    <h3>{{ textCodeEmailVerification }}</h3>
  </div>
</ng-container>

<ng-template #viewVerification>
  <div class="content-valid" *ngIf="viewVerificationValid">
    <mat-icon class="mat-icon-valid">check_circle_outline</mat-icon>
    <strong class="text-foot">{{ textVerificationValid }}</strong>
  </div>

  <div class="content-valid" *ngIf="viewVerificationIncorrect">
    <mat-icon class="mat-icon-error">highlight_off</mat-icon>
    <strong class="text-foot">{{ textVerificationInvalid }}</strong>
  </div>
</ng-template>
